import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./components/Home/Home";
import ProductPage from "./pages/ProductPage/ProductPage";
import ProductForm from "./pages/ProductUpload/ProductForm";
import ProductList from "./pages/ProductList/ProductList";
import JewelleryPlans from "./pages/jewelPlans/JewelleryPlans";
import AboutUs from "./detailPages/aboutus/AboutUs";
import PrivacyPolicy from "./detailPages/privacyPolicy/PrivacyPolicy";
import ContactUs from "./detailPages/ContactUs/ContactUs";
import ExchangePolicy from "./detailPages/Exchange/ExchangePolicy";
import Return from "./detailPages/Returns/Returns";
import Shipping from "./detailPages/Shipping/Shipping";
import ProductDetailPage from "./pages/ProductDetailPage/ProductDetailPage"
import AnimeCards from "./components/checking/AnimeCards";
import BuyNowPage from "./pages/Buynow/BuyNowPage";
import AuthPage from "./sessionDetails/AuthPage";
import CartPage from "./majorPages/CartPage";
import ProfilePage from "./sessionDetails/ProfilePage";
import ProfileOrders from "./pages/ProfileOrders/ProfileOrders";
import TermsAndConditions from "./detailPages/termsandcondition/TermsAndConditions"
import OrderSuccessPage from "./pages/OrderSuccessPage/OrderSuccessPage";

const AppRoutes = () => {


    const BuyNowPageWrapper = () => {
        const location = useLocation();
        const { state } = location;
        return <BuyNowPage product={state?.product} />;
      };
    return (


        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/product-upload" element={<ProductForm />} />
            <Route path="/product-list" element={<ProductList />} />
            <Route path="/schemes" element={<JewelleryPlans />} />
            <Route path="/aboutus" element={<AboutUs />} />
         
            <Route path="/contactus" element={<ContactUs />} />




            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/exchange-policy" element={<ExchangePolicy />} />
            <Route path="/return-policy" element={<Return />} />
            <Route path="/shipping-policy" element={<Shipping />} />


            <Route path="/payment-success" element={<OrderSuccessPage />} />

            <Route path="/product/:id" element={<ProductDetailPage />} />
            <Route path="/buy-now" element={<BuyNowPageWrapper />} />
      
           <Route path="/login" element={<AuthPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/order-success" element={<OrderSuccessPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/profile/orders" element={<ProfileOrders />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Routes>

    );
};

export default AppRoutes;
